
import dayjs from 'dayjs';
export default () => {
    let time = dayjs();
    return {
        pointDate: time.format("YYYYMMDD"),
        pointTime: time.format("YYYY-MM-DD HH:mm:ss"),
        pointTimestamp: time.valueOf()
    };
};